import { Qualifications, qualificationsNaming } from '../../../api/typesDc';
import { PAGE } from './typeInterfaces';
export enum OPTIONSENUM {
  ACADEMYPROFITABILITY = 'academyprofitability',
  CLUBINCOME = 'clubincome',
  CLUBCOSTS = 'clubcosts',
  ACADEMYCOSTSCLUBCOSTS = 'academycostsclubcosts',
  ACADEMYINCOME = 'academyincome',
  TOTALACADEMYCOSTS = 'totalacademycosts',
  LABOUR = 'labour',
  FACILITIES = 'facilities',
  TRAVEL = 'travel',
  EQUIPMENTFIXTURES = 'equipmentfixtures',
  U18S = 'u18s',
  U15S = 'u15s',
  U12DEVELOPMENTCENTRE = 'u12/development centre',
  SOCCERSCHOOL = 'soccer school',
  JLEAGUESUPPORTFUND = 'jLeaguesupportfund',
  MEMBERSHIPFEEINCOME = 'membershipfeeincome',
  OTHER = 'other',
  PLAYERSPRODUCED = 'playersProduced',
  IPLAYERSPRODUCED = 'iplayersProduced',
  TOURNAMENTWINS = 'tournamentWins',
  // Ranking
  CLUBSPEND = 'clubspend',
  ACADEMYSPEND = 'academyspend',
  CLUBSPENDONACADEMY = 'clubspendonacademy',
  LABOURCOST = 'labourcost',
  // STAFF
  TOTALSTAFF = 'totalstaff',
  STAFFCOSTS = 'staffcosts',
  QUALIFIEDCOACHES = 'qualifiedcoaches',
  AVERAGESALARY = 'averagesalary',

  FOOTBALL = 'football',
  DIRECTOROFFICE = 'directoroffice',
  OPERATIONS = 'operations',
  SCOUTING = 'scouting',
  MEDICAL = 'medical',
  PLAYERCARE = 'playercare',
  PERMENANTSTAFF = 'permenantstaff',
  TEMPORARYSTAFF = 'temporarystaff',
  COACHESSAQUALIFIED = 'coachessaqualified',
  QUALIFICATIONSLIST = 'qualificationslist',
  TOPTEAMDIRECTOR = 'topteamdirector',
  TOPTEAMCOACH = 'topteamcoach',
  ACADEMICDIRECTOR = 'academydirector',
  ACADEMICTEAMDIRECTOR = 'academicteamdirector',
  ACADEMICTEAMCOACH = 'academicteamcoach',
  SCHOOLCOACH = 'schoolcoach',
  FULLTIME = 'fulltime',
  PROFESSIONALCONTRACT = 'professtionalcontract',
  PARTTIME = 'parttime',
  STUDENT = 'student',
  OTHEREMPLOYMENTSTATUS = 'volunteer',

  // FACILITIES
  FACILITESCOSTS = 'facilitiescosts',
  TOTALFACILITIES = 'totalfacilities',
  PERCENTAGEOWNED = 'percentageowned',
  PERCENTAGEPRIORITY = 'percentagepriority',
  PERCENTAGEPUBLIC = 'percentagepublic',
  WITHMEDICALROOMS = 'withmedicalrooms',
  WITHDORMITORIES = 'withdormitories',
  WITHCHANGINGROOMS = 'withchangingrooms',
  WITHCLUBHOUSE = 'withclubhouse',
  WITHHOTSHOWERS = 'withhotshowers',
  WITHCOLDSHOWERS = 'withcoldshowers',
  WITHADULTGOALS = 'withadultgoals',
  WITHJUNIORGOALS = 'withjuniorgoals',
  WITHKIDSGOALS = 'withkidsgoals',
  CHANGINGROOMS = 'changingrooms',
  DORMITORYCAPACITY = 'dormitorycapacity',
  TOTALPITCHES = 'totalpitches',
  NATURALPITCHES = 'naturalpitches',
  ARTIFICIALPITCHES = 'artificialpitches',
  ILLUMINATEDPITCHES = 'illuminatedpitches',
  WITHSPECTATORS = 'withspectators',
  TOTALSPECTATORS = 'totalspectators',
  TOTALPITCHSQUAREX = 'totalpitchsquareX',
  // TEAMS
  TOTALTEAMS = 'totalteams',
  TOTALEXPENSES = 'totalexpenses',
  PLAYEREXPENSES = 'playerexpenses',
  TRAVELEXPENSES = 'travelexpenses',
  ADMISSIONFEES = 'admissionfees',
  TOTALPLAYERS = 'totalplayers',
  COACHESPERTEAM = 'coachesperteam',
  GKCOACHESPERTEAM = 'gkcoachesperteam',
  MEDICALSTAFFPERTEAM = 'medicalstaffperteam',
  SAQUALIFIEDPERTEAM = 'saqualifiedperteam',
  TRAININGHOURS = 'traininghours',
  TOTALCOMPETITIONS = 'totalcompititions',
  U9 = 'u9',
  U10 = 'u10',
  U11 = 'u11',
  U12 = 'u12',
  U13 = 'u13',
  U14 = 'u14',
  U15 = 'u15',
  U16 = 'u16',
  U17 = 'u17',
  U18 = 'u18',
  // PLAYERS
  AVERAGETIMEATACADEMY = 'averagetimeatacademy',
  PLAYERSPROMOTEDTO1STLIST = 'playerspromotedto1stlist',
  PLAYERSAPEARINGFOROTHERCLUBS = 'playersapearingforotherclub',
  INTERNATIONALPLAYERS = 'internationalplayers',
  YOUTHINTERNATIONALLAST5YEARS = 'youthinternationallast5years',
  INLAST2YEARS = 'inlast2years',
  INLAST5YEARS = 'inlast5years',
}

interface OptionValue {
  id: OPTIONSENUM;
  name: string;
}

export const headingsValue: { [key in OPTIONSENUM]: OptionValue } = {
  [OPTIONSENUM.ACADEMYPROFITABILITY]: {
    id: OPTIONSENUM.ACADEMYPROFITABILITY,
    name: 'ACADEMY_PROFITABILITY',
  },
  [OPTIONSENUM.CLUBINCOME]: {
    id: OPTIONSENUM.CLUBINCOME,
    name: 'CLUB_INCOME',
  },
  [OPTIONSENUM.CLUBCOSTS]: {
    id: OPTIONSENUM.CLUBCOSTS,
    name: 'CLUB_COSTS',
  },
  [OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS]: {
    id: OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS,
    name: 'ACADEMY_COSTS_%_CLUB_COSTS',
  },
  [OPTIONSENUM.ACADEMYINCOME]: {
    id: OPTIONSENUM.ACADEMYINCOME,
    name: 'ACADEMY_INCOME',
  },
  [OPTIONSENUM.TOTALACADEMYCOSTS]: {
    id: OPTIONSENUM.TOTALACADEMYCOSTS,
    name: 'TOTAL_ACADEMY_COSTS',
  },
  [OPTIONSENUM.LABOUR]: {
    id: OPTIONSENUM.LABOUR,
    name: 'DC_3_LABOUR_COST',
  },
  [OPTIONSENUM.FACILITIES]: {
    id: OPTIONSENUM.FACILITIES,
    name: 'DC_3_FACILITIES',
  },
  [OPTIONSENUM.TRAVEL]: {
    id: OPTIONSENUM.TRAVEL,
    name: 'DC_3_TRAVEL',
  },
  [OPTIONSENUM.EQUIPMENTFIXTURES]: {
    id: OPTIONSENUM.EQUIPMENTFIXTURES,
    name: 'DC_3_EQUIPMENT_FIXTURES',
  },
  [OPTIONSENUM.U18S]: {
    id: OPTIONSENUM.U18S,
    name: 'DC_3_U18S',
  },
  [OPTIONSENUM.U15S]: {
    id: OPTIONSENUM.U15S,
    name: 'DC_3_U15S',
  },
  [OPTIONSENUM.U12DEVELOPMENTCENTRE]: {
    id: OPTIONSENUM.U12DEVELOPMENTCENTRE,
    name: 'DC_3_DEV_CENTRE',
  },
  [OPTIONSENUM.SOCCERSCHOOL]: {
    id: OPTIONSENUM.SOCCERSCHOOL,
    name: 'DC_3_SOCCER_SCHOOL',
  },
  [OPTIONSENUM.JLEAGUESUPPORTFUND]: {
    id: OPTIONSENUM.JLEAGUESUPPORTFUND,
    name: 'DC_3_J_LEAGUE_SUPPORT_FUND',
  },
  [OPTIONSENUM.MEMBERSHIPFEEINCOME]: {
    id: OPTIONSENUM.MEMBERSHIPFEEINCOME,
    name: 'DC_3_MEMBERSHIP_FEE_INCOME',
  },
  [OPTIONSENUM.OTHER]: {
    id: OPTIONSENUM.OTHER,
    name: 'DC_3_OTHER',
  },
  [OPTIONSENUM.PLAYERSPRODUCED]: {
    id: OPTIONSENUM.PLAYERSPRODUCED,
    name: 'PLAYERS_PRODUCED',
  },
  [OPTIONSENUM.IPLAYERSPRODUCED]: {
    id: OPTIONSENUM.IPLAYERSPRODUCED,
    name: 'INTERNATIONAL_PLAYERS_PRODUCED',
  },
  [OPTIONSENUM.TOURNAMENTWINS]: {
    id: OPTIONSENUM.TOURNAMENTWINS,
    name: 'TOURNEMANT_WINS',
  },
  [OPTIONSENUM.CLUBSPEND]: {
    id: OPTIONSENUM.CLUBSPEND,
    name: 'CLUB_SPEND',
  },
  [OPTIONSENUM.ACADEMYSPEND]: {
    id: OPTIONSENUM.ACADEMYSPEND,
    name: 'ACADEMY_SPEND',
  },
  [OPTIONSENUM.CLUBSPENDONACADEMY]: {
    id: OPTIONSENUM.CLUBSPENDONACADEMY,
    name: 'CLUB_SPEND_ON_ACADEMY',
  },
  [OPTIONSENUM.LABOURCOST]: {
    id: OPTIONSENUM.LABOURCOST,
    name: 'DC_3_LABOUR_COST',
  },
  //
  [OPTIONSENUM.TOTALSTAFF]: {
    id: OPTIONSENUM.TOTALSTAFF,
    name: 'TOTAL_STAFF',
  },
  [OPTIONSENUM.STAFFCOSTS]: {
    id: OPTIONSENUM.STAFFCOSTS,
    name: 'STAFF_COSTS',
  },
  [OPTIONSENUM.QUALIFIEDCOACHES]: {
    id: OPTIONSENUM.QUALIFIEDCOACHES,
    name: 'QUALIFIED_COACHES',
  },
  [OPTIONSENUM.AVERAGESALARY]: {
    id: OPTIONSENUM.AVERAGESALARY,
    name: 'AVERAGE_SALARY',
  },
  //
  [OPTIONSENUM.FOOTBALL]: {
    id: OPTIONSENUM.FOOTBALL,
    name: 'FOOTBALL',
  },
  [OPTIONSENUM.DIRECTOROFFICE]: {
    id: OPTIONSENUM.DIRECTOROFFICE,
    name: 'DIRECTOR_OFFICE',
  },
  [OPTIONSENUM.OPERATIONS]: {
    id: OPTIONSENUM.OPERATIONS,
    name: 'OPERATIONS',
  },
  [OPTIONSENUM.SCOUTING]: {
    id: OPTIONSENUM.SCOUTING,
    name: 'SCOUTING',
  },
  [OPTIONSENUM.MEDICAL]: {
    id: OPTIONSENUM.MEDICAL,
    name: 'MEDICAL',
  },
  [OPTIONSENUM.PLAYERCARE]: {
    id: OPTIONSENUM.PLAYERCARE,
    name: 'PLAYER_CARE_&_EDUCATION',
  },
  [OPTIONSENUM.PERMENANTSTAFF]: {
    id: OPTIONSENUM.PERMENANTSTAFF,
    name: 'PERMANENT_STAFF',
  },
  [OPTIONSENUM.TEMPORARYSTAFF]: {
    id: OPTIONSENUM.TEMPORARYSTAFF,
    name: 'TEMPORARY_STAFF',
  },
  [OPTIONSENUM.COACHESSAQUALIFIED]: {
    id: OPTIONSENUM.COACHESSAQUALIFIED,
    name: '%_COACHES_S/A_QUALIFIED',
  },
  [OPTIONSENUM.QUALIFICATIONSLIST]: {
    id: OPTIONSENUM.QUALIFICATIONSLIST,
    name: 'QUALIFICATIONS_LIST',
  },
  [OPTIONSENUM.TOPTEAMDIRECTOR]: {
    id: OPTIONSENUM.TOPTEAMDIRECTOR,
    name: 'DC_RP_TOP_TEAM_DIRECTOR',
  },
  [OPTIONSENUM.TOPTEAMCOACH]: {
    id: OPTIONSENUM.TOPTEAMCOACH,
    name: 'DC_RP_ACADEMY_DIRECTOR',
  },
  [OPTIONSENUM.ACADEMICDIRECTOR]: {
    id: OPTIONSENUM.ACADEMICDIRECTOR,
    name: 'DC_RP_HEAD_COACH',
  },
  [OPTIONSENUM.ACADEMICTEAMDIRECTOR]: {
    id: OPTIONSENUM.ACADEMICTEAMDIRECTOR,
    name: 'DC_RP_ACADEMIC_TEAM_DIRECTOR',
  },
  [OPTIONSENUM.ACADEMICTEAMCOACH]: {
    id: OPTIONSENUM.ACADEMICTEAMCOACH,
    name: 'DC_RP_ACADEMIC_TEAM_COACH',
  },
  [OPTIONSENUM.SCHOOLCOACH]: {
    id: OPTIONSENUM.SCHOOLCOACH,
    name: 'DC_RP_SCHOOL_COACH',
  },
  [OPTIONSENUM.FACILITESCOSTS]: {
    id: OPTIONSENUM.FACILITESCOSTS,
    name: 'FACILITIES_COSTS',
  },
  [OPTIONSENUM.TOTALFACILITIES]: {
    id: OPTIONSENUM.TOTALFACILITIES,
    name: 'TOTAL_FACILITIES',
  },
  [OPTIONSENUM.PERCENTAGEOWNED]: {
    id: OPTIONSENUM.PERCENTAGEOWNED,
    name: '%_OWNED',
  },
  [OPTIONSENUM.PERCENTAGEPRIORITY]: {
    id: OPTIONSENUM.PERCENTAGEPRIORITY,
    name: '%_PRIORITY',
  },
  [OPTIONSENUM.PERCENTAGEPUBLIC]: {
    id: OPTIONSENUM.PERCENTAGEPUBLIC,
    name: '%_PUBLIC',
  },
  [OPTIONSENUM.WITHMEDICALROOMS]: {
    id: OPTIONSENUM.WITHMEDICALROOMS,
    name: 'WITH_MEDICAL_ROOMS',
  },
  [OPTIONSENUM.WITHDORMITORIES]: {
    id: OPTIONSENUM.WITHDORMITORIES,
    name: 'WITH_DORMITORIES',
  },
  [OPTIONSENUM.WITHCHANGINGROOMS]: {
    id: OPTIONSENUM.WITHCHANGINGROOMS,
    name: 'WITH_CHANGING_ROOMS',
  },
  [OPTIONSENUM.WITHCLUBHOUSE]: {
    id: OPTIONSENUM.WITHCLUBHOUSE,
    name: 'WITH_CLUB_HOUSE',
  },
  [OPTIONSENUM.WITHHOTSHOWERS]: {
    id: OPTIONSENUM.WITHHOTSHOWERS,
    name: 'WITH_HOT_SHOWERS',
  },
  [OPTIONSENUM.WITHCOLDSHOWERS]: {
    id: OPTIONSENUM.WITHCOLDSHOWERS,
    name: 'WITH_COLD_SHOWERS',
  },
  [OPTIONSENUM.WITHADULTGOALS]: {
    id: OPTIONSENUM.WITHADULTGOALS,
    name: 'WITH_ADULT_GOALS',
  },
  [OPTIONSENUM.WITHJUNIORGOALS]: {
    id: OPTIONSENUM.WITHJUNIORGOALS,
    name: 'WITH_JUNIOR_GOALS',
  },
  [OPTIONSENUM.WITHKIDSGOALS]: {
    id: OPTIONSENUM.WITHKIDSGOALS,
    name: 'WITH_KIDS_GOALS',
  },
  [OPTIONSENUM.CHANGINGROOMS]: {
    id: OPTIONSENUM.CHANGINGROOMS,
    name: 'DC_CAP_CHANGING_ROOMS',
  },
  [OPTIONSENUM.DORMITORYCAPACITY]: {
    id: OPTIONSENUM.DORMITORYCAPACITY,
    name: 'DC_6_DORMITORY_CAPACITY',
  },
  [OPTIONSENUM.TOTALPITCHES]: {
    id: OPTIONSENUM.TOTALPITCHES,
    name: 'TOTAL_PITCHES',
  },
  [OPTIONSENUM.NATURALPITCHES]: {
    id: OPTIONSENUM.NATURALPITCHES,
    name: 'NATURAL_PITCHES',
  },

  [OPTIONSENUM.ARTIFICIALPITCHES]: {
    id: OPTIONSENUM.ARTIFICIALPITCHES,
    name: 'ARTIFICIAL_PITCHES',
  },
  [OPTIONSENUM.ILLUMINATEDPITCHES]: {
    id: OPTIONSENUM.ILLUMINATEDPITCHES,
    name: 'ILLUMINATED_PITCHES',
  },
  [OPTIONSENUM.WITHSPECTATORS]: {
    id: OPTIONSENUM.WITHSPECTATORS,
    name: 'WITH_SPECTATORS',
  },
  [OPTIONSENUM.TOTALSPECTATORS]: {
    id: OPTIONSENUM.TOTALSPECTATORS,
    name: 'TOTAL_SPECTATORS',
  },
  [OPTIONSENUM.TOTALPITCHSQUAREX]: {
    id: OPTIONSENUM.TOTALPITCHSQUAREX,
    name: 'TOTAL_PITCH_SQUARE',
  },
  [OPTIONSENUM.TOTALTEAMS]: {
    id: OPTIONSENUM.TOTALTEAMS,
    name: 'TOTAL_TEAMS',
  },
  [OPTIONSENUM.TOTALEXPENSES]: {
    id: OPTIONSENUM.TOTALEXPENSES,
    name: 'EXPENSE_TOTAL',
  },
  [OPTIONSENUM.PLAYEREXPENSES]: {
    id: OPTIONSENUM.PLAYEREXPENSES,
    name: 'PLAYER_EXPENSES',
  },
  [OPTIONSENUM.TRAVELEXPENSES]: {
    id: OPTIONSENUM.TRAVELEXPENSES,
    name: 'DC_3_TRAVEL',
  },
  [OPTIONSENUM.ADMISSIONFEES]: {
    id: OPTIONSENUM.ADMISSIONFEES,
    name: 'DC_7_ADMISSION_FEES',
  },
  [OPTIONSENUM.TOTALPLAYERS]: {
    id: OPTIONSENUM.TOTALPLAYERS,
    name: 'TOTAL_PLAYERS',
  },
  [OPTIONSENUM.COACHESPERTEAM]: {
    id: OPTIONSENUM.COACHESPERTEAM,
    name: 'COACHES_PER_TEAM',
  },
  [OPTIONSENUM.GKCOACHESPERTEAM]: {
    id: OPTIONSENUM.GKCOACHESPERTEAM,
    name: 'GK_COACHES_PER_TEAM',
  },
  [OPTIONSENUM.MEDICALSTAFFPERTEAM]: {
    id: OPTIONSENUM.MEDICALSTAFFPERTEAM,
    name: 'MEDICAL_STAFF_PER_TEAM',
  },
  [OPTIONSENUM.SAQUALIFIEDPERTEAM]: {
    id: OPTIONSENUM.SAQUALIFIEDPERTEAM,
    name: 'SA_QUALIFIED_PER_TEAM',
  },
  [OPTIONSENUM.TRAININGHOURS]: {
    id: OPTIONSENUM.TRAININGHOURS,
    name: 'TRAINING_HOURS',
  },
  [OPTIONSENUM.TOTALCOMPETITIONS]: {
    id: OPTIONSENUM.TOTALCOMPETITIONS,
    name: 'TOTAL_COMPETITIONS',
  },
  [OPTIONSENUM.U9]: {
    id: OPTIONSENUM.U9,
    name: 'DC_AG_U9',
  },
  [OPTIONSENUM.U10]: {
    id: OPTIONSENUM.U10,
    name: 'DC_AG_U10',
  },
  [OPTIONSENUM.U11]: {
    id: OPTIONSENUM.U11,
    name: 'DC_AG_U11',
  },
  [OPTIONSENUM.U12]: {
    id: OPTIONSENUM.U12,
    name: 'DC_AG_U12',
  },
  [OPTIONSENUM.U13]: {
    id: OPTIONSENUM.U13,
    name: 'DC_AG_U13',
  },
  [OPTIONSENUM.U14]: {
    id: OPTIONSENUM.U14,
    name: 'DC_AG_U14',
  },
  [OPTIONSENUM.U15]: {
    id: OPTIONSENUM.U15,
    name: 'DC_AG_U15',
  },
  [OPTIONSENUM.U16]: {
    id: OPTIONSENUM.U16,
    name: 'DC_AG_U16',
  },
  [OPTIONSENUM.U17]: {
    id: OPTIONSENUM.U17,
    name: 'DC_AG_U17',
  },
  [OPTIONSENUM.U18]: {
    id: OPTIONSENUM.U18,
    name: 'DC_AG_U18',
  },
  [OPTIONSENUM.AVERAGETIMEATACADEMY]: {
    id: OPTIONSENUM.AVERAGETIMEATACADEMY,
    name: 'AVERAGE_TIME_AT_ACADEMY',
  },
  [OPTIONSENUM.PLAYERSPROMOTEDTO1STLIST]: {
    id: OPTIONSENUM.PLAYERSPROMOTEDTO1STLIST,
    name: 'Players_Promoted_to_1st_List',
  },
  [OPTIONSENUM.PLAYERSAPEARINGFOROTHERCLUBS]: {
    id: OPTIONSENUM.PLAYERSAPEARINGFOROTHERCLUBS,
    name: 'Players_Appearing_for_Other_Clubs',
  },
  [OPTIONSENUM.INTERNATIONALPLAYERS]: {
    id: OPTIONSENUM.INTERNATIONALPLAYERS,
    name: 'International Players',
  },
  [OPTIONSENUM.YOUTHINTERNATIONALLAST5YEARS]: {
    id: OPTIONSENUM.YOUTHINTERNATIONALLAST5YEARS,
    name: 'Youth International Last 5 Years',
  },
  [OPTIONSENUM.INLAST2YEARS]: {
    id: OPTIONSENUM.INLAST2YEARS,
    name: 'In_Last_2_Years',
  },
  [OPTIONSENUM.INLAST5YEARS]: {
    id: OPTIONSENUM.INLAST5YEARS,
    name: 'In_Last_5_Years',
  },
  [OPTIONSENUM.FULLTIME]: {
    id: OPTIONSENUM.FULLTIME,
    name: 'DC_ES_FULL_TIME',
  },
  [OPTIONSENUM.PARTTIME]: {
    id: OPTIONSENUM.PARTTIME,
    name: 'DC_ES_PART_TIME',
  },
  [OPTIONSENUM.PROFESSIONALCONTRACT]: {
    id: OPTIONSENUM.PROFESSIONALCONTRACT,
    name: 'DC_ES_CONSULTANT',
  },
  [OPTIONSENUM.STUDENT]: {
    id: OPTIONSENUM.STUDENT,
    name: 'DC_ES_STUDENT',
  },
  [OPTIONSENUM.OTHEREMPLOYMENTSTATUS]: {
    id: OPTIONSENUM.OTHEREMPLOYMENTSTATUS,
    name: 'OTHER_EMPLOYMENTSTATUS',
  },
};

const timeLineLevels = {
  [OPTIONSENUM.ACADEMYPROFITABILITY]: [],
  [OPTIONSENUM.CLUBINCOME]: [],
  [OPTIONSENUM.CLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYINCOME]: [OPTIONSENUM.MEMBERSHIPFEEINCOME],
  [OPTIONSENUM.TOTALACADEMYCOSTS]: [
    OPTIONSENUM.LABOURCOST,
    OPTIONSENUM.FACILITIES,
    OPTIONSENUM.TRAVEL,
    OPTIONSENUM.EQUIPMENTFIXTURES,
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
    OPTIONSENUM.OTHER,
  ],
  [OPTIONSENUM.LABOURCOST]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.FACILITIES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.TRAVEL]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.EQUIPMENTFIXTURES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.OTHER]: [OPTIONSENUM.U18S, OPTIONSENUM.U15S, OPTIONSENUM.U12DEVELOPMENTCENTRE, OPTIONSENUM.SOCCERSCHOOL],
};

const staffTimeLineLevels = {
  [OPTIONSENUM.TOTALSTAFF]: [
    OPTIONSENUM.FULLTIME,
    OPTIONSENUM.PROFESSIONALCONTRACT,
    OPTIONSENUM.PARTTIME,
    OPTIONSENUM.STUDENT,
    OPTIONSENUM.OTHEREMPLOYMENTSTATUS,
  ],
  [OPTIONSENUM.STAFFCOSTS]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.QUALIFIEDCOACHES]: [
    OPTIONSENUM.COACHESSAQUALIFIED,
    {
      id: Qualifications.DC_Q_QUALIFICATION1,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION1],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION2,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION2],
    },
    // {
    //   id: Qualifications.DC_Q_QUALIFICATION3,
    //   label: (qualificationsNaming[Qualifications.DC_Q_QUALIFICATION3]),
    // },
    {
      id: Qualifications.DC_Q_QUALIFICATION4,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION4],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION5,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION5],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION6,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION6],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION7,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION7],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION8,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION8],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION9,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION9],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION10,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION10],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION11,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION11],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION12,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION12],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION13,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION13],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION14,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION14],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION15,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION15],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION16,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION16],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION17,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION17],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION18,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION18],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION19,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION19],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION20,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION20],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION21,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION21],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION22,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION22],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION23,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION23],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION24,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION24],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION25,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION25],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION26,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION26],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION27,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION27],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION28,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION28],
    },
    {
      id: Qualifications.DC_Q_QUALIFICATION29,
      label: qualificationsNaming[Qualifications.DC_Q_QUALIFICATION29],
    },
  ],
  [OPTIONSENUM.AVERAGESALARY]: [
    OPTIONSENUM.FULLTIME,
    OPTIONSENUM.PROFESSIONALCONTRACT,
    OPTIONSENUM.PARTTIME,
    OPTIONSENUM.STUDENT,
    OPTIONSENUM.OTHEREMPLOYMENTSTATUS,
    OPTIONSENUM.TOPTEAMCOACH,
    OPTIONSENUM.ACADEMICDIRECTOR,
    OPTIONSENUM.ACADEMICTEAMDIRECTOR,
    OPTIONSENUM.ACADEMICTEAMCOACH,
    OPTIONSENUM.SCHOOLCOACH,
    OPTIONSENUM.OTHER,
  ],
};

const roiLevels = {
  [OPTIONSENUM.ACADEMYPROFITABILITY]: [],
  [OPTIONSENUM.CLUBINCOME]: [],
  [OPTIONSENUM.CLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYINCOME]: [OPTIONSENUM.JLEAGUESUPPORTFUND, OPTIONSENUM.MEMBERSHIPFEEINCOME, OPTIONSENUM.OTHER],
  [OPTIONSENUM.TOTALACADEMYCOSTS]: [
    OPTIONSENUM.LABOURCOST,
    OPTIONSENUM.FACILITIES,
    OPTIONSENUM.TRAVEL,
    OPTIONSENUM.EQUIPMENTFIXTURES,
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
    OPTIONSENUM.OTHER,
  ],
  [OPTIONSENUM.LABOURCOST]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.FACILITIES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.TRAVEL]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.EQUIPMENTFIXTURES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
};

const roiReturnOptions = {
  [OPTIONSENUM.PLAYERSPRODUCED]: [],
  [OPTIONSENUM.IPLAYERSPRODUCED]: [],
  [OPTIONSENUM.TOURNAMENTWINS]: [],
};

const benchmarkingLevels = {
  [OPTIONSENUM.ACADEMYPROFITABILITY]: [],
  [OPTIONSENUM.CLUBINCOME]: [],
  [OPTIONSENUM.CLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS]: [],
  [OPTIONSENUM.ACADEMYINCOME]: [OPTIONSENUM.JLEAGUESUPPORTFUND, OPTIONSENUM.MEMBERSHIPFEEINCOME],
  [OPTIONSENUM.TOTALACADEMYCOSTS]: [
    OPTIONSENUM.OTHER,
    OPTIONSENUM.SOCCERSCHOOL,
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.EQUIPMENTFIXTURES,
    OPTIONSENUM.TRAVEL,
    OPTIONSENUM.FACILITIES,
    OPTIONSENUM.LABOURCOST,
  ],
  [OPTIONSENUM.LABOURCOST]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.FACILITIES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.TRAVEL]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.EQUIPMENTFIXTURES]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.OTHER]: [OPTIONSENUM.U18S, OPTIONSENUM.U15S, OPTIONSENUM.U12DEVELOPMENTCENTRE, OPTIONSENUM.SOCCERSCHOOL],
};
const facilitiesTimeLineLevels = {
  [OPTIONSENUM.FACILITESCOSTS]: [
    OPTIONSENUM.U18S,
    OPTIONSENUM.U15S,
    OPTIONSENUM.U12DEVELOPMENTCENTRE,
    OPTIONSENUM.SOCCERSCHOOL,
  ],
  [OPTIONSENUM.TOTALFACILITIES]: [
    OPTIONSENUM.PERCENTAGEOWNED,
    OPTIONSENUM.PERCENTAGEPRIORITY,
    OPTIONSENUM.PERCENTAGEPUBLIC,
    OPTIONSENUM.WITHMEDICALROOMS,
    OPTIONSENUM.WITHDORMITORIES,
    OPTIONSENUM.WITHCHANGINGROOMS,
    OPTIONSENUM.WITHCLUBHOUSE,
    OPTIONSENUM.WITHHOTSHOWERS,
    OPTIONSENUM.WITHCOLDSHOWERS,
    OPTIONSENUM.WITHADULTGOALS,
    OPTIONSENUM.WITHJUNIORGOALS,
    OPTIONSENUM.WITHKIDSGOALS,
  ],
  [OPTIONSENUM.CHANGINGROOMS]: [],
  [OPTIONSENUM.DORMITORYCAPACITY]: [],
  [OPTIONSENUM.TOTALPITCHES]: [
    OPTIONSENUM.NATURALPITCHES,
    OPTIONSENUM.ARTIFICIALPITCHES,
    OPTIONSENUM.ILLUMINATEDPITCHES,
    OPTIONSENUM.WITHSPECTATORS,
  ],
  [OPTIONSENUM.TOTALSPECTATORS]: [],
  [OPTIONSENUM.TOTALPITCHSQUAREX]: [],
};

const teamsTimeLineLevels = {
  [OPTIONSENUM.TOTALTEAMS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.TOTALEXPENSES]: [OPTIONSENUM.PLAYEREXPENSES, OPTIONSENUM.TRAVELEXPENSES],
  [OPTIONSENUM.PLAYEREXPENSES]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.TRAVELEXPENSES]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.ADMISSIONFEES]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],

  [OPTIONSENUM.TOTALPLAYERS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],

  [OPTIONSENUM.COACHESPERTEAM]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],

  [OPTIONSENUM.GKCOACHESPERTEAM]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.MEDICALSTAFFPERTEAM]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.SAQUALIFIEDPERTEAM]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.TRAININGHOURS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.TOTALCOMPETITIONS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
  [OPTIONSENUM.TOURNAMENTWINS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
};

const teamsBenchmarkingLevels = {
  [OPTIONSENUM.TOTALTEAMS]: [OPTIONSENUM.TOTALTEAMS],
  [OPTIONSENUM.TOTALEXPENSES]: [OPTIONSENUM.TOTALEXPENSES],
  [OPTIONSENUM.PLAYEREXPENSES]: [OPTIONSENUM.PLAYEREXPENSES],
  [OPTIONSENUM.TRAVELEXPENSES]: [OPTIONSENUM.TRAVELEXPENSES],
  [OPTIONSENUM.ADMISSIONFEES]: [OPTIONSENUM.ADMISSIONFEES],

  [OPTIONSENUM.TOTALPLAYERS]: [OPTIONSENUM.TOTALPLAYERS],

  [OPTIONSENUM.COACHESPERTEAM]: [OPTIONSENUM.COACHESPERTEAM],

  [OPTIONSENUM.GKCOACHESPERTEAM]: [OPTIONSENUM.GKCOACHESPERTEAM],
  [OPTIONSENUM.MEDICALSTAFFPERTEAM]: [OPTIONSENUM.MEDICALSTAFFPERTEAM],
  [OPTIONSENUM.SAQUALIFIEDPERTEAM]: [OPTIONSENUM.SAQUALIFIEDPERTEAM],
  [OPTIONSENUM.TRAININGHOURS]: [OPTIONSENUM.TRAININGHOURS],
  [OPTIONSENUM.TOTALCOMPETITIONS]: [OPTIONSENUM.TOTALCOMPETITIONS],
  [OPTIONSENUM.TOURNAMENTWINS]: [OPTIONSENUM.TOURNAMENTWINS],
};

const playersTimelineLevels = {
  [OPTIONSENUM.TOTALPLAYERS]: [OPTIONSENUM.INLAST2YEARS, OPTIONSENUM.INLAST5YEARS],
  [OPTIONSENUM.AVERAGETIMEATACADEMY]: [],
  [OPTIONSENUM.PLAYERSPROMOTEDTO1STLIST]: [OPTIONSENUM.INLAST2YEARS, OPTIONSENUM.INLAST5YEARS],
  [OPTIONSENUM.PLAYERSAPEARINGFOROTHERCLUBS]: [OPTIONSENUM.INLAST2YEARS, OPTIONSENUM.INLAST5YEARS],
  [OPTIONSENUM.INTERNATIONALPLAYERS]: [OPTIONSENUM.INLAST2YEARS, OPTIONSENUM.INLAST5YEARS],
  [OPTIONSENUM.YOUTHINTERNATIONALLAST5YEARS]: [
    OPTIONSENUM.U9,
    OPTIONSENUM.U10,
    OPTIONSENUM.U11,
    OPTIONSENUM.U12,
    OPTIONSENUM.U13,
    OPTIONSENUM.U14,
    OPTIONSENUM.U15,
    OPTIONSENUM.U16,
    OPTIONSENUM.U17,
    OPTIONSENUM.U18,
  ],
};

const getValues = (keyArray: OPTIONSENUM[]) => {
  return keyArray?.map(key => {
    if (typeof key === 'string') {
      return headingsValue[key];
    } else {
      return key;
    }
  });
};

const getFirstLevelOptions = (levels:any): OptionValue[] => {
  const firstLevelKeys = Object.keys(levels);
  return getValues(firstLevelKeys as OPTIONSENUM[]) ?? [];
};

const getSecondLevelOptions = (key:any, levels:any) => {
  const secondLevelKeys = levels[key];
  return getValues(secondLevelKeys) ?? [];
};

/**
 * Get the first dropdown list for timeline
 * @returns
 */
export const getTimeLineFirstLevelOptions = (page:any) => {
  let levels: any = timeLineLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
  } else if (page == PAGE.TEAMS) {
    levels = teamsTimeLineLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getFirstLevelOptions(levels);
};

/**
 * Get the second dropdown list based on first dropdown selection for timeline
 * @returns
 */
export const getTimeLineSecondLevelOptions = (page:any, key:any) => {
  let levels: any = timeLineLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
    return getSecondLevelOptions(key, levels);
  } else if (page == PAGE.TEAMS) {
    levels = teamsTimeLineLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getSecondLevelOptions(key, levels);
};

/**
 * Get the first dropdown list for ROI
 * @returns
 */
export const getROIFirstLevelOptions = (page:any) => {
  let levels: any = roiLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
  } else if (page == PAGE.TEAMS) {
    levels = teamsTimeLineLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getFirstLevelOptions(levels);
};

/**
 * Get the second dropdown list based on first dropdown selection for ROI
 * @returns
 */
export const getROISecondLevelOptions = (page:any, key:any) => {
  let levels: any = roiLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
  } else if (page == PAGE.TEAMS) {
    levels = teamsTimeLineLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getSecondLevelOptions(key, levels);
};

/**
 * Get the second dropdown list based on first dropdown selection for ROI
 * @returns
 */
export const getROIReturnOptions = (page:any) => {
  let levels = roiReturnOptions;
  if (page == PAGE.STAFF) {
    levels = roiReturnOptions;
  }
  return getFirstLevelOptions(levels);
};

/**
 * Get the first dropdown list for Bench marking
 * @returns
 */
export const getBenchmarkingFirstLevelOptions = (page:any) => {
  let levels: any = benchmarkingLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
  } else if (page == PAGE.TEAMS) {
    levels = teamsBenchmarkingLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getFirstLevelOptions(levels);
};

/**
 * Get the second dropdown list based on first dropdown selection for Benchmarking
 * @returns
 */
export const getBenchmarkingSecondLevelOptions = (page:any, key:any) => {
  let levels: any = benchmarkingLevels;
  if (page == PAGE.STAFF) {
    levels = staffTimeLineLevels;
  } else if (page == PAGE.FACILITIES) {
    levels = facilitiesTimeLineLevels;
  } else if (page == PAGE.TEAMS) {
    levels = teamsBenchmarkingLevels;
  } else if (page == PAGE.PLAYERS) {
    levels = playersTimelineLevels;
  }
  return getSecondLevelOptions(key, levels);
};
